module.exports = __webpack_public_path__ + "img/item_part_driver.7a55bcd1.png";